export enum AgentChatStatusEnum {
  Ready = 'READY',
  Streaming = 'STREAMING',
  Submitted = 'SUBMITTED',
}
